import { ViewComponentProps } from '@databases/fields/view/types';
import { DatabaseFieldType } from '@databases/types/database';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.span<{ newlines?: boolean }>`
  white-space: pre-line;
`;

const TextValueView: FunctionComponent<ViewComponentProps<DatabaseFieldType.TEXT>> = ({
  field,
  value,
}) => {
  const resolvedValue = field.settings.newlines
    ? value
    : value.replace(/\r\n|\n|\r/g, ' ');

  return <Container>{resolvedValue}</Container>;
};

export default TextValueView;
